// Both editors use the same identity, search terms and contact replacement.
export function agencyDetails(agency) {
  const contact = agency?.mainContact || {};
  const names = String(contact.name || agency?.agent_name || '').trim().split(/\s+/);
  return {
    agent_first_name: names[0] || '',
    agent_last_name: names.slice(1).join(' '),
    agency_company_name: agency?.company_name || '',
    agent_phone: contact.phone || agency?.phone || agency?.contactInfo || '',
    agent_email: contact.email || agency?.email || '',
  };
}

export function agencyOption(agency) {
  const label = agency.company_name || agency.preferredName || agency.agent_name || agency.id;
  return {
    id: agency.id,
    label,
    detail: agency.preferredName !== label ? agency.preferredName || '' : '',
    searchText: [label, agency.preferredName, agency.agent_name, agency.mainContact?.name,
      agency.mainContact?.email, agency.mainContact?.phone, agency.mainContact?.wechatId, agency.email, agency.phone, agency.contactInfo, agency.id]
      .filter(Boolean).join(' ').toLowerCase(),
  };
}

export function selectAgency(form, id, agents) {
  if (id === form.agent_id) return form;
  // Linking an agency answers "how did you hear about us" too, the same way the
  // server does (_heard_about_for_agency_state): a record whose Source column
  // links to an agency profile cannot claim a different source. Unlinking keeps
  // the previous answer rather than erasing the only one we were given.
  return { ...form, using_agency: typeof form.using_agency === 'string' ? (id ? 'true' : 'false') : Boolean(id), agent_id: id, heard_about_us: id ? 'agency' : form.heard_about_us || '', ...agencyDetails(agents.find((agency) => agency.id === id)) };
}
